import { PropsWithChildren } from 'react';

import * as Sentry from '@sentry/react';

import { FullPageErrorFallback, PartialErrorFallback } from '../error-fallbacks';

export const fallbacks = {
  full: FullPageErrorFallback,
  partial: PartialErrorFallback,
};

export type FallbackType = keyof typeof fallbacks;

export type ErrorFallbackProps = {
  error: unknown;
  componentStack: string;
  resetError: () => void;
};

type ErrorBoundaryProps = {
  name: string;
  fallbackType?: FallbackType;
  renderFallback?: (props: ErrorFallbackProps) => React.ReactElement;
};

export const ErrorBoundary: React.FC<PropsWithChildren<ErrorBoundaryProps>> = ({
  name,
  fallbackType = 'partial',
  children,
  renderFallback,
}) => (
  <Sentry.ErrorBoundary
    fallback={renderFallback ?? fallbacks[fallbackType]}
    beforeCapture={scope => scope.setTransactionName(name)}
  >
    {children}
  </Sentry.ErrorBoundary>
);
